import { useMutation } from '@tanstack/react-query';
import { deleteSubareaRequest } from '../requests/deleteSubareaRequest';
import { Alert } from '../../../components/Alert';
import { queryClient } from '../../../app/App';
import { AxiosError } from 'axios';

export function useDeleteSubarea() {
	const deleteSubarea = useMutation({
		mutationFn: async (id: number) => {
			return deleteSubareaRequest(id);
		},
		onSuccess: () => {
			Alert({ message: 'Successfully deleted!', type: 'success' });
			queryClient.invalidateQueries(['SUBAREA_LIST']);
		},
		onError: (error: AxiosError) => {
			Alert({ message: error.message, type: 'error' });
		},
	});

	return {
		deleteSubarea,
	};
}
